import { injectable } from "inversify";
import Testing from "../../../ui/utils/Testing";
import AIRepository from "../../../domain/repositories/AIRepository";

@injectable()
class AIRepositoryFake implements AIRepository {
    getAISumaries = async (params: string, channel: string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    getAIChats = async (): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    getAISumaryByRecord = async (record: string, channel: string): Promise<any> =>  {
        await Testing.sleeper(1000);
        return [];
    }
    getAIChat = async (chatId: string): Promise<any> =>  {
        await Testing.sleeper(1000);
        return [];
    }
    getAIChatParsedFiles = async (chatId: string, body?: any): Promise<any> =>  {
        await Testing.sleeper(1000);
        return [];
    }
    getNewAIEvaluation = async (record: string): Promise<any> =>  {
        await Testing.sleeper(1000);
        return [];
    }
    getAIEmbedURL = async (dashboardName: string): Promise<any> =>  {
        await Testing.sleeper(1000);
        return [];
    }
    searchAISummaries = async (query: any): Promise<any> =>  {
        await Testing.sleeper(1000);
        return [];
    }
    searchAISummariesByTranscription = async (params: any): Promise<any> =>  {
        await Testing.sleeper(1000);
        return [];
    }
    searchAISummariesLanguages = async (): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    searchAISummariesEntities = async (): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    getAIAgents = async (customer: string, lob: string, channel: string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    getAICustomers = async (channel: string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    getAIPerson = async (query: any, type: string, params: string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    getAIChatsByCustomer = async (query: any, type: string, params: string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    getAIEmailsByCustomer = async (query: any, type: string, params: string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    updateAISumaryByRecord = async (record: string, content: any, channel: string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    UpdateAISwapByRecord  = async (record: string, content: any): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    UpdateAISummaryInDisputeByRecord = async (record: string, content: any): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    UpdateAISummaryInDisputeCommentsByRecord = async (record: string, content: any): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    GetAISummaryInDisputeCommentsByRecord = async (record: string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    getAIMoments = async (keywords: string[], page: number, type: string, customer: string, lob: string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    GetAIMomentsOptions = async (): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    UpdateAIMomentById = async (content: any, keyword_id: number, value: any | undefined): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    CreateAIMoment = async (customer: string, lob: string, type: string, description: string, weight: number, options: string, sec_response: string, channel:string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    DeleteAIMoment = async(keyword_id: number): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    
    getAIS3RagPath = async (filename: string, customer: string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    
    getAIS3RagRegisteredPath = async (filename: string, customer: string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    GetS3RagListByCustomer = async (customer: string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    DeleteS3RagDocument = async (customer: string, document: string): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    getNews = async (): Promise<any> => {
        await Testing.sleeper(1000);
        return [];
    }
    uploadChannel = async (params: { customer: string; lob: string; user_id: string; date: string; channel: string; file?: File }): Promise<any> => {
        await Testing.sleeper(1000);
        return { success: true, message: "Channel uploaded successfully (fake)", filename: params.file?.name, user_id: params.user_id };
    }
}
export default AIRepositoryFake;